import * as React from "react";
import { connect } from "react-redux";
import { useIntl } from "react-intl";
import { Formik, Field, Form } from "formik";
import { Routine } from "redux-saga-routines";
import {Action, ActionFunctionAny} from "redux-actions";
import { Col, Grid } from "react-bootstrap";
import styled from "styled-components";

import {SettingEnum, SettingEnum as ComponentSettingEnum} from "../../settingEnum";
import { ManDownForm  } from "../types";
import { Footer, ButtonContainer, StyledForm } from "./styled";
import { SettingsLayout, Section, FieldGrid } from "../../Components/settingsLayout";
import withFormWrapper from "@Elements/Form/formWrapper";
import Toggle from "@Elements/Switch/Toggle";
import { RadioGroup, Radio } from "../../../../Elements/RadioFormik";
import { CancelButton, SaveButton } from "../../../DefaultSettings/Settings/styled";
import { saveManDownSettings } from "../../Store/routines";
import { AppState } from "@Safemate/Store/types";

interface ManDownSettingsProps {
    dehaId: number;
    deviId: number;
    manDownSettings: ManDownForm;
    saveManDownSettings: Routine<ActionFunctionAny<Action<any>>>;
    components: Map<SettingEnum, JSX.Element[]>;
}
  
const mapStateToProps = ({ settings: {initialization: { deviId, dehaId }, general: {manDownSettings}}}: AppState) => {
return{
    manDownSettings,
    dehaId,
    deviId
}
}

const mapDispatchToProps = {
    saveManDownSettings
}

const StyledCol = styled(Col)`
    margin-bottom: 1em;
`;

const StyledGrid = styled(Grid)`
    width: 100%;
`;


const TitleWrapper = styled.div`

    padding: 10px 0;

`;


export const ManDown = connect(mapStateToProps, mapDispatchToProps)(
({ dehaId, deviId, manDownSettings, saveManDownSettings, components }: ManDownSettingsProps) => {

    const { formatMessage } = useIntl();


    
    return(
    <Formik
        onSubmit={(values) => {
            saveManDownSettings({deviceId: deviId, settings: values})}
        }
        enableReinitialize
        initialValues={manDownSettings}
    >    
        {({dirty, setValues}) => {
        return(
            <StyledForm>
            <SettingsLayout>
            <h2>{formatMessage({id: "manDownSettings", defaultMessage: "Man down innstillinger"})}</h2>
            <Section>
                <FieldGrid>
                {components.has(ComponentSettingEnum.MAN_DOWN_SETTINGS) 
                    && components.get(ComponentSettingEnum.MAN_DOWN_SETTINGS)?.map((comp, i) => 
                    <div key={i}>{comp}</div>)}
                </FieldGrid>
            </Section>
            </SettingsLayout>
            <Footer>
                <ButtonContainer disabled={!dirty}>
                <CancelButton disabled={!dirty} onClick={() => setValues(manDownSettings)}>
                    {formatMessage({id: "cancel", defaultMessage: "Avbryt"})}
                </CancelButton>
                <SaveButton disabled={!dirty} type="submit">
                    {formatMessage({id: "save", defaultMessage: "Lagre"})}
                </SaveButton>
                </ButtonContainer>
            </Footer>
            </StyledForm>
        )}}
    </Formik>
    )
})


export const FallDownAlarm = 
  withFormWrapper<ManDownForm, {}>(({ formik: { setFieldValue, values: { fallDownAlert } } }) => {

    const { formatMessage } = useIntl();

    return(
      <React.Fragment>
        <h3>{formatMessage({id: "fallDownAlert", defaultMessage: "Fallalarm"})}</h3>
        <div>
        <Toggle
          onChange={(value: boolean) => {
            setFieldValue("fallDownAlert", value);
          }}
          checked={fallDownAlert}
        />
        </div>
      </React.Fragment>
    )
  }
)

export const WatchTwoRadioManDown = 
  withFormWrapper<ManDownForm, {}>(({ formik: { setFieldValue, values: { fallDownSensitivity, fallDownAlert } } }) => {

    const { formatMessage } = useIntl();


    React.useMemo(() => {
      setFieldValue("fallDownSensitivity", fallDownSensitivity.toString());
      if(fallDownSensitivity == 0 || fallDownSensitivity == "0"){
        setFieldValue("fallDownAlert",false);
      }else{
        setFieldValue("fallDownAlert",true);
      }
    }, [fallDownSensitivity])



    
    

    return(
      <React.Fragment>
        <h3>{formatMessage({id: "fallDownAlert", defaultMessage: "Fallalarm"})}</h3>
        <div>
        <RadioGroup disabled={false}>
              <Field
                component={Radio}
                name="fallDownSensitivity"
                radioValue={"0"}
                id="fall-down-1"
                label={formatMessage({id: 'manDownOff', defaultMessage: 'Off'})}
                />
              <Field
                component={Radio}
                name="fallDownSensitivity"
                id="fall-down-2"
                radioValue={"1"}
                label={formatMessage({id:'manDownLowSensitivity', defaultMessage: 'Low sensitivity'})}
              />
              <Field
                component={Radio}
                name="fallDownSensitivity"
                radioValue={"2"}
                id="fall-down-3"
                label={formatMessage({
                  id: 'manDownHighSensitivity',
                  defaultMessage: 'High Sensitivity'
                })}
              />
            </RadioGroup>
        </div>
      </React.Fragment>
    )
  }
)
  
  
export const TiltAlert = 
withFormWrapper<ManDownForm, {}>(({ formik: { setFieldValue, values: { tiltAlert } } }) => {

  const { formatMessage } = useIntl();

  return(
    <React.Fragment>
      <h3>{formatMessage({id: "tiltAlert", defaultMessage: "Tiltalarm"})}</h3>
      <div>
      <Toggle
        onChange={(value: boolean) => {
          setFieldValue("tiltAlert", value);
        }}
        checked={tiltAlert}
      />
      </div>
    </React.Fragment>
  )
}
)
